/**
 * Remembers the arguments of the last list fetch per entity.
 *
 * A list screen keeps its page, page size, search text and filters in half a
 * dozen separate pieces of state, so "reload what is currently on screen" is
 * hard to reconstruct from the outside. The list actions record what they were
 * asked for here, and a realtime refresh simply replays it - the user keeps
 * their page and their filters instead of being bounced back to page 1.
 */

const queries = new Map();

/** Called by the list actions with the params they just used. */
export const rememberQuery = (entity, params) => {
  if (entity) queries.set(entity, params);
};

/** Params of the last fetch for this entity, or `fallback` if there was none. */
export const lastQuery = (entity, fallback) => {
  const stored = queries.get(entity);
  return stored === undefined ? fallback : stored;
};

export const forgetQuery = (entity) => {
  queries.delete(entity);
};

const queryMemory = { forgetQuery, lastQuery, rememberQuery };

export default queryMemory;
